import {
  CELL_CONNECT_KIND,
  CELL_REFUSAL_REASON,
  IConfirmationDelayInput,
  IConnectError
} from "@/store/apis/cellsAPI/cells.types"

const AUTOMATIC_SPREAD_MS = 2000
const RETURN_WINDOW_MS = 5000
const REOPEN_BASE_MS = 2000
const REOPEN_CAP_MS = 30000

export const classifyConnectError = (
  error: IConnectError,
  active: boolean
): CELL_REFUSAL_REASON => {
  const reason = error.data?.reason
  if (reason === CELL_REFUSAL_REASON.UNAUTHORIZED) {
    return CELL_REFUSAL_REASON.UNAUTHORIZED
  }
  if (reason === CELL_REFUSAL_REASON.UNAVAILABLE || !active) {
    return CELL_REFUSAL_REASON.UNAVAILABLE
  }
  return CELL_REFUSAL_REASON.TRANSPORT
}

export const reopenDelayMs = (failures: number, random: () => number): number =>
  random() * Math.min(REOPEN_BASE_MS * 2 ** failures, REOPEN_CAP_MS)

export const confirmationDelayMs = ({
  kind,
  firstOfConnection,
  msSinceReturn,
  random
}: IConfirmationDelayInput): number =>
  kind === CELL_CONNECT_KIND.AUTOMATIC &&
  firstOfConnection &&
  (msSinceReturn === null || msSinceReturn > RETURN_WINDOW_MS)
    ? random() * AUTOMATIC_SPREAD_MS
    : 0

export const isNewToken = (
  current: string | null,
  refused: string | null
): boolean => current !== null && current !== "" && current !== refused
